import React from 'react';
import useScopedTranslation from 'hooks/useScopedTranslation';
import { textEditorVariablesI18n } from './i18n';

export default function TextEditorVariables({
  variableGroups = [],
  onInsert,
}) {
  const { t } = useScopedTranslation(textEditorVariablesI18n);

  const handleClick = (placeholder) => {
    if (!placeholder) return;
    onInsert?.(placeholder);
  };

  const handleDragStart = (e, placeholder) => {
    e.dataTransfer.setData('text/plain', placeholder);
  };

  return (
    <div
      className='border rounded-3 p-3'
      style={{ minWidth: 260, maxWidth: 280, background: '#f8fafc' }}
    >
      <h4 className='mini fw-semibold mb-2'>{t('textEditor_title')}</h4>
      <p className='mini color-gray-600 mb-3'>{t('textEditor_description')}</p>

      <div className='d-flex flex-column gap-3'>
        {variableGroups.map((group) => (
          <div key={group.label}>
            <div className='mini fw-semibold mb-1'>{group.label}</div>
            <div className='d-flex flex-wrap gap-2'>
              {group.variables.map((v) => (
                <button
                  key={v.placeholder}
                  type='button'
                  className='btn btn-light btn-sm'
                  draggable
                  onDragStart={(e) => handleDragStart(e, v.placeholder)}
                  onClick={() => handleClick(v.placeholder)}
                  style={{ fontSize: 12, borderRadius: 999 }}
                >
                  {v.label}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
